/**
 * Which date pulls the price a Leistung is billed at.
 *
 * Not a property of § 125 versus § 125a — a property of **each Anlage-2
 * document**. Four verbs across seven documents — the five § 125 Anlagen plus
 * the two § 125a (#1413 § 14): Physio
 * _durchgeführt_, Ergo and SSSST _erbracht_, Podologie _stattfinden_ — all three
 * keyed on the day of treatment — and Ernährungstherapie _"für Verordnungen ab
 * dem …, die ab dem … ausgestellt wurden"_, keyed on the day the Verordnung was
 * written. A practice holding an Ernährungstherapie Verordnung ausgestellt
 * 15.05.2026 bills the old table for treatments delivered in 2027.
 *
 * Three verbs, one basis: `BEHANDLUNGSDATUM` deliberately covers _durchgeführt_,
 * _erbracht_ and _stattfinden_ alike. Inventing three members would encode a
 * distinction no contract makes.
 *
 * ⚠ Podologie needs **both** dates: its price table is chosen by
 * Behandlungsdatum while its UI1/UI2 position set is chosen by Verordnungsdatum
 * (#1413 § 6.4). That second axis is not a price basis and is not modelled here.
 */
export var PriceBasis;
(function (PriceBasis) {
    /** The day the treatment was delivered. */
    PriceBasis["BEHANDLUNGSDATUM"] = "behandlungsdatum";
    /** The day the Verordnung was issued. */
    PriceBasis["VERORDNUNGSDATUM"] = "verordnungsdatum";
})(PriceBasis || (PriceBasis = {}));
/**
 * Refuse anything that is not one of the two published bases.
 *
 * The twin of `assertLeistungserbringerGroups`, and there for the same reason:
 * the value arrives from a committed JSON artefact and from a nullable database
 * column, neither of which TypeScript can vouch for. A basis nobody published
 * would silently pick the day of treatment at the one place a contract says
 * otherwise.
 */
export function assertPriceBasis(value, context) {
    if (!Object.values(PriceBasis).includes(value)) {
        throw new Error(`${context}: ${JSON.stringify(value)} names no published price basis ` +
            `(${Object.values(PriceBasis).join(', ')}). The document states which date its prices ` +
            `are pulled by; it is not assumed.`);
    }
}
//# sourceMappingURL=price-basis.enum.js.map